export var MessageBoxType;
(function (MessageBoxType) {
    MessageBoxType[MessageBoxType["Error"] = 1] = "Error";
    MessageBoxType[MessageBoxType["Info"] = 2] = "Info";
    MessageBoxType[MessageBoxType["Question"] = 3] = "Question";
    MessageBoxType[MessageBoxType["Warning"] = 4] = "Warning";
    MessageBoxType[MessageBoxType["Approve"] = 5] = "Approve";
    MessageBoxType[MessageBoxType["YellowInfo"] = 6] = "YellowInfo";
})(MessageBoxType || (MessageBoxType = {}));
export var MessageBoxResult;
(function (MessageBoxResult) {
    MessageBoxResult[MessageBoxResult["Ok"] = 0] = "Ok";
    MessageBoxResult[MessageBoxResult["Cancel"] = 1] = "Cancel";
})(MessageBoxResult || (MessageBoxResult = {}));
export var MessageBoxButtonsTextKey;
(function (MessageBoxButtonsTextKey) {
    MessageBoxButtonsTextKey["Ok"] = "general.messageBox.ok";
})(MessageBoxButtonsTextKey || (MessageBoxButtonsTextKey = {}));
